let constants = {
    Roles: {
        CustomerAdminRole: 'General Admin',
        FleetUserRole: 'Fleet User',
        SystemRole: 'System Admin',
        CSRRole: 'TruckDown CSR'
    },
    Claims: {
        Name: 'name',
        Roles: 'role',
        ApiKey: 'apikey',
        LocalLogin: 'll',
        RealUser: 'run',
        ThirdPartyLogin: 'tpl',
        RequiresLocalLogin: 'rll'
    },
    Events: {
        NotificationReceived: "notification_received",
        NotificationDismissed: "notification_dismissed",
        NotificationClicked: "notification_clicked",
        NotificationPermissionChanged: "notification_permission_changed",
        NotificationsInitialized: "notification_initialized",
        ReceivedEvent: "received_event"
    },
    Settings: {
        ExternalId: "external_id"
    }
};
export const Constants = constants;